import type { StandardResource } from "../types";

export function sortStandardResources(resources: StandardResource[]): StandardResource[] {
  return [...resources].sort((a, b) => a.sortOrder - b.sortOrder || a.createdAt.localeCompare(b.createdAt));
}
